function App() {
  const src = process.env.REACT_APP_REPORT_URL;

  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <h1
        style={{
          flex: "0",
          color: "white",
          margin: "0",
          paddingTop: "20px",
          paddingBottom: "20px",
        }}
        className="bg-white"
      >
        &nbsp;
      </h1>
      <iframe
        title="ubb_PRESUPUESTO_01_Presupuesto - beta"
        width="100%"
        src={src}
        frameBorder="0"
        allowFullScreen
        style={{ flex: 1 }}
      ></iframe>
    </div>
  );
}

export default App;
